interface HeroConfig {
  eyebrow: string;
  headline: string;
  dek: string;
  primaryCta: { label: string; to: string };
  secondaryCta: { label: string; href: string };
}

export const heroConfig: HeroConfig = {
  eyebrow: 'Writing by Chad Crossman',
  headline: "Ideas, projects, and whatever I'm thinking about.",
  dek: 'Personal writing on software, building things, and everything in between.',
  primaryCta: { label: 'Browse posts', to: '/categories' },
  secondaryCta: { label: 'About me', href: '/about' },
};

interface AboutConfig {
  seoDescription: string;
  heading: string;
  paragraphs: string[];
}

export const aboutConfig: AboutConfig = {
  seoDescription: 'CITO-focused technology leader specialising in Business Architecture, capability-driven transformation, and aligning strategy to delivery.',
  heading: 'About',
  paragraphs: [
    "Most organisations don't fail because of poor engineering. They fail because they are exceptionally good at building the wrong things.",

    "I focus on solving that problem.",

    "My work sits at the intersection of business strategy, technology, and transformation—ensuring organisations don't just deliver software, but deliver the right outcomes.",

    "While many technology leaders focus on systems, platforms, and delivery, I focus on capability—what the business must be able to do to compete and win.",

    "This is the shift from CTO to CITO.",

    "A traditional CTO ensures that technology is built well. A CITO ensures that the right things are built at all.",

    "My approach is grounded in Business Architecture, using a structured model that connects value, strategy, capability, technology, and delivery into a single, coherent system.",

    "Value → Strategy → Capability → Technology → Delivery",

    "This ensures that every investment, every backlog item, and every architectural decision can be traced back to a clear business outcome.",

    "I work with organisations to:",
    "• Define and prioritise business capabilities",
    "• Align technology strategy to business outcomes",
    "• Fix broken Agile and SAFe implementations",
    "• Introduce capability-driven investment models",
    "• Reduce waste and improve strategic clarity",

    "Across organisations, I consistently see the same failure patterns, misaligned investment, disconnected backlogs, and reactive architecture.",

    "The solution is not more process, more tools, or more frameworks.",

    "The solution is clarity.",

    "Clarity of value. Clarity of capability. Clarity of intent.",

    "That is the role I operate in.",
  ],
};

interface HeaderConfig {
  logoUrl?: string;
}

export const headerConfig: HeaderConfig = {
  logoUrl: 'https://publishweaver-public-resources.s3.us-east-1.amazonaws.com/blog/personal/chad-crossman-cartoon.png',
};

export const siteConfig = {
  name:        import.meta.env.VITE_SITE_TITLE,
  shortName:   import.meta.env.VITE_SITE_TITLE,
  description: import.meta.env.VITE_SITE_DESCRIPTION,
  siteUrl:     import.meta.env.VITE_SITE_URL,
  mainSiteUrl: 'https://publishweaver.com',
  social: {
    x:        'https://x.com/publishweaver',
    linkedin: 'https://www.linkedin.com/company/publishweaver'
  },
  nav: [
    { label: 'Home',       to: '/' },
    { label: 'Categories', to: '/categories' },
    { label: 'Tags',       to: '/tags' },
    { label: 'About',      to: '/about' }
  ]
} as const;
